var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChangeRoadNum(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    overflow: "visible",
    viewBox: "0 0 40 40",
    width: "100%",
    height: "100%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "#6D6D6D",
    fillOpacity: 0.7,
    rx: 20
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M23.909 19.58q0 .997-.148 1.996a7.6 7.6 0 0 1-.49 1.866 5.1 5.1 0 0 1-.966 1.554q-.622.672-1.587 1.064-.966.375-2.324.376-.344 0-.785-.032a3.6 3.6 0 0 1-.72-.115v-1.456q.654.195 1.44.196 1.112 0 1.849-.327.752-.345 1.178-.95.425-.604.622-1.407a8.4 8.4 0 0 0 .229-1.701h-.098q-.36.555-.999.965-.638.393-1.718.393-1.521 0-2.438-.933-.9-.95-.9-2.65 0-1.85 1.03-2.914 1.032-1.063 2.766-1.063 1.146 0 2.062.556.917.556 1.457 1.702.54 1.13.54 2.88m-4.042-3.715q-.933 0-1.522.622-.59.623-.59 1.898 0 1.049.508 1.653.507.606 1.538.606.72 0 1.244-.295.524-.294.818-.753.295-.458.295-.949 0-.654-.262-1.292a2.5 2.5 0 0 0-.77-1.064q-.505-.426-1.26-.426"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M23.096 32.38a9.4 9.4 0 0 1-1.47.267 14 14 0 0 1-1.47.08q-2.513 0-4.745-.894a13.1 13.1 0 0 1-3.969-2.47A12.9 12.9 0 0 1 8.61 25.65a12.7 12.7 0 0 1-1.336-4.619h1.63A9.8 9.8 0 0 0 10 24.849 11.7 11.7 0 0 0 12.392 28c.971.908 3.314 2.203 3.314 2.203l2.266-2.23zM16.905 7.62a9.4 9.4 0 0 1 1.472-.267q.777-.08 1.5-.08 2.49 0 4.738.894 2.25.895 3.976 2.47a13 13 0 0 1 2.825 3.712 12.3 12.3 0 0 1 1.311 4.619h-1.606a9.8 9.8 0 0 0-1.098-3.818 11.7 11.7 0 0 0-2.396-3.151c-.973-.908-3.32-2.203-3.32-2.203l-2.27 2.23z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChangeRoadNum);
export default __webpack_public_path__ + "static/media/ChangeRoadNum.19d0f5731b23b76834cf1fbe44f85950.svg";
export { ForwardRef as ReactComponent };